import { Component, EventEmitter, Input, OnDestroy, OnInit, Output } from '@angular/core';
import { HelperService } from 'src/app/core/services/helper.service';
import { opacityInOut } from 'src/app/shared/animations/opacity-in-out.animation';
import { scaleInOut } from 'src/app/shared/animations/scale-in-out.animation';

export interface VacancyWarningPopupProps {
  vacancyTitle: string;
  jobId: string | null;
  submitLabel: string;
  cancelLabel: string;
  warningMessage: string;
  loadingLabel?: string;
}

@Component({
  selector: 'vacancy-warning-popup',
  templateUrl: './vacancy-warning-popup.component.html',
  styleUrls: ['./vacancy-warning-popup.component.scss'],
  animations: [opacityInOut, scaleInOut]
})
export class VacancyWarningPopupComponent implements OnInit, OnDestroy {

  @Input() props: VacancyWarningPopupProps;
  @Input() isLoading = false;

  @Output() action = new EventEmitter<boolean | null>();

  constructor(private helperService: HelperService) {}

  ngOnInit(): void {
    this.helperService.blockScroll$.next(true);
  }

  ngOnDestroy(): void {
    this.helperService.blockScroll$.next(false);
  }

  onClose(): void {
    if (this.isLoading) return;
    this.action.emit(null);
  }

  onCancel(): void {
    if (this.isLoading) return;
    this.action.emit(false);
  }

  onSubmit(): void {
    if (this.isLoading) return;
    this.action.emit(true);
  }
}
